import { createSelector } from 'reselect'
import * as R from 'ramda'

import { FILE_TYPES, TOPOLOGY_FILE_TYPE } from './constants'
import { formattedFileSelector } from 'containers/Project/FileSection/selectors'
import { curRevisionIdSelector } from 'containers/Project/NvqualSection/selectors'

const filesSelector = createSelector(
  formattedFileSelector,
  curRevisionIdSelector,
  (files, curRevisionId) => {
    const projectFiles = R.filter(R.compose(
      R.flip(R.contains)(FILE_TYPES),
      R.prop('fileType')
    ))(files)
    const curRevisionFiles = file => {
      const validFile = R.not(R.isEmpty(file)) 
      // show files for current revision id only
      const curRevisionFile = R.propEq('revisionId', curRevisionId)(file)
      const topologyFile = R.propEq('fileType', TOPOLOGY_FILE_TYPE)(file)
      // also show topology file regardless of revision id
      return R.and(validFile, R.or(curRevisionFile, topologyFile))
    }
      return R.filter(curRevisionFiles, projectFiles)
  }
)

export {
  filesSelector
}
